var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('b-button',{style:({color: 'white', backgroundColor: _vm.show ? 'darkgray' : 'black' }),attrs:{"size":"sm"},on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.year)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }